import React, { useState, lazy } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = [{
    quote: "This book took me straight back to the smell of popcorn and the sound of Huey Lewis. It's pure nostalgia.",
    author: 'Kevin R., San Diego, CA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sAkrP5KJZPcgvCUSMiV772/1.png'
  }, {
    quote: 'Reading this felt like watching the trilogy for the first time again. I had tears in my eyes by Chapter Two.',
    author: 'Laura P., Chicago, IL',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hbJweZwSKdeNkYWbdErmrN/5.png'
  }, {
    quote: 'The behind-the-scenes stories made me appreciate just how much heart went into this film.',
    author: 'Brandon T., Orlando, FL',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gHcbDgG51oK7Gh3NjAYGDa/2.png'
  }, {
    quote: 'A masterpiece for collectors. If you grew up with Marty and Doc, like we did, this is your time machine.',
    author: 'Newman Family, Boston, MA',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k5uGmvWP6Z3JLguVC5UCZM/3.png'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-6 md:py-8 bg-bttf-bg/90 relative" data-id="element-358">
      <div className="absolute inset-0 bg-gradient-to-r from-bttf-highlight/10 to-transparent opacity-30" data-id="element-359"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-360">
        <div className="text-center mb-6" data-id="element-361">
          <div className="flex justify-center mb-2" data-id="element-362">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-363" />
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-364" />
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-365" />
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-366" />
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-367" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-368">
            What Readers Are Saying
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-369"></div>
        </div>
        <div className="max-w-5xl mx-auto relative" data-id="element-370">
          {/* Carousel Container */}
          <div className="relative overflow-hidden rounded-lg" data-id="element-371">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-372">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-373">
                  <div className="flex flex-col md:flex-row items-center gap-6 bg-bttf-bg/80 p-6 rounded-lg border border-bttf-accent/30 shadow-lg backdrop-blur-sm" data-id="element-374">
                    {/* Image */}
                    <div className="w-full md:w-1/2" data-id="element-375">
                      <div className="relative" data-id="element-376">
                        <div className="absolute -inset-1 bg-gradient-main rounded-lg blur-sm opacity-50" data-id="element-377"></div>
                        <img src={testimonial.image} alt={testimonial.author} className="relative w-full h-auto rounded-lg shadow-xl object-cover" loading="lazy" data-id="element-378" />
                      </div>
                    </div>
                    {/* Testimonial Text */}
                    <div className="w-full md:w-1/2 flex flex-col justify-center" data-id="element-379">
                      <p className="text-xl md:text-2xl mb-4 italic text-bttf-text leading-relaxed" data-id="element-380">
                        {`"${testimonial.quote}"`}
                      </p>
                      <p className="text-lg font-medium text-bttf-accent" data-id="element-381">
                        — {testimonial.author}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Buttons */}
          <button onClick={() => setCurrentIndex(prev => prev === 0 ? testimonials.length - 1 : prev - 1)} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Previous testimonial" data-id="element-382">
            <ChevronLeftIcon className="h-6 w-6" data-id="element-383" />
          </button>
          <button onClick={() => setCurrentIndex(prev => prev === testimonials.length - 1 ? 0 : prev + 1)} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text p-3 rounded-full shadow-neon-orange transition-all duration-300 hover:scale-110 z-10" aria-label="Next testimonial" data-id="element-384">
            <ChevronRightIcon className="h-6 w-6" data-id="element-385" />
          </button>
          {/* Dots Navigation */}
          <div className="flex justify-center gap-3 mt-6" data-id="element-386">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-bttf-primary shadow-neon-orange w-8' : 'bg-bttf-subtext/50 hover:bg-bttf-subtext'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-387" />)}
          </div>
        </div>
      </div>
    </section>;
};